import { render, staticRenderFns } from "./PageSkeleton.vue?vue&type=template&id=4fcd5d80&scoped=true"
var script = {}
import style0 from "./PageSkeleton.vue?vue&type=style&index=0&id=4fcd5d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd5d80",
  null
  
)

export default component.exports